import { OrganizationChartDesignTokens } from '@primeuix/themes/types/organizationchart';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t, tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/organizationchart/index.ts
const oc = componentCommon.organizationchart;
const ocDeep = tDeep(oc);

export const OrganizationchartTelekomDT: OrganizationChartDesignTokens = {
  root: {
    gutter: t(oc.gutter),
  },
  node: {
    background: t(oc.node.background),
    hoverBackground: t(oc.node.hover.background),
    selectedBackground: t(oc.node.selected.background),
    borderColor: t(oc.node.border.color),
    color: t(oc.node.color),
    selectedColor: t(oc.node.selected.color),
    hoverColor: t(oc.node.hover.color),
    padding: `${ocDeep.node.padding.y} ${ocDeep.node.padding.x}`,
    toggleablePadding: `${ocDeep.node.toggleable.padding.top} ${ocDeep.node.toggleable.padding.right} ${ocDeep.node.toggleable.padding.bottom} ${ocDeep.node.toggleable.padding.left}`,
    borderRadius: t(oc.node.border.radius),
  },
  nodeToggleButton: {
    background: t(oc.node.toggle.button.background),
    hoverBackground: t(oc.node.toggle.button.hover.background),
    borderColor: t(oc.node.toggle.button.border.color),
    color: t(oc.node.toggle.button.color),
    hoverColor: t(oc.node.toggle.button.hover.color),
    size: t(oc.node.toggle.button.size),
    borderRadius: t(oc.node.toggle.button.border.radius),
    focusRing: {
      width: t(oc.node.toggle.button.focus.ring.width),
      color: t(oc.node.toggle.button.focus.ring.color),
      offset: t(oc.node.toggle.button.focus.ring.offset),
    },
  },
  connector: {
    color: t(oc.connector.color),
    borderRadius: t(oc.connector.border.radius),
    height: t(oc.connector.height),
  },
};
